module.exports = __webpack_public_path__ + "static/media/FrancineSouza.009b84bc.jpg";